/* Decorative only: no scroll listeners, timers, animation loops, or layout reads. */
(() => {
  if (window.dacPearlSparkles) return;
  window.dacPearlSparkles = true;
  const selector = 'img.dac-sparkle[data-dac-sparkle="ambient"]';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  const known = new Set();
  const visible = new Set();
  const awake = new Set();
  let observer;
  let index = 0;

  function reconcile() {
    const next = new Set();
    if (!document.hidden && !motion.matches && !connection?.saveData) {
      for (const star of visible) {
        if (star.isConnected) next.add(star);
        if (next.size === 6) break;
      }
    }
    for (const star of awake) if (!next.has(star)) star.classList.remove('dac-sparkle--awake');
    for (const star of next) if (!awake.has(star)) star.classList.add('dac-sparkle--awake');
    awake.clear();
    next.forEach(star => awake.add(star));
  }
  function configure() {
    observer?.disconnect();
    observer = null;
    visible.clear();
    reconcile();
    if (motion.matches || connection?.saveData || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.intersectionRatio > 0) visible.add(entry.target);
        else visible.delete(entry.target);
      }
      reconcile();
    }, { threshold: [0, .1] });
    known.forEach(star => observer.observe(star));
  }
  function collect(root) {
    root.querySelectorAll(selector).forEach(star => {
      if (known.has(star)) return;
      known.add(star);
      star.style.setProperty('--dac-sparkle-duration', `${9 + index % 4}s`);
      star.style.setProperty('--dac-sparkle-delay', `${-(index++ * 2.3 % 10)}s`);
      observer?.observe(star);
    });
  }
  collect(document);
  configure();
  motion.addEventListener('change', configure);
  connection?.addEventListener('change', configure);
  document.addEventListener('visibilitychange', reconcile);
  document.addEventListener('shopify:section:load', event => collect(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const star of known) if (event.target.contains(star)) {
      observer?.unobserve(star);
      known.delete(star);
      visible.delete(star);
    }
    reconcile();
  });
})();
